import {path} from 'ramda'
import {CollectionFactory} from '@modifi/redux'
import {createSelector} from 'reselect'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: 'transaction/available-refinancing-partners',
  rootSelector: state => state?.modules?.refinancingPartners,
  reducerPath: ['transactions', 'refinancingPartners'],
  fetchRequest: (state, {transactionId}) => {
    const client = getAuthenticatedAdminAresClient()
    return client.BankTransactions.availableRefinancingPartners({transactionId}).then(
      res => res.data().refinancingPartners
    )
  },
  entityPrimaryKeySelector: path(['tag']),
})

export default reducer

const selectAvailableRefinancingPartnersFetchCount = state => transactionId =>
  selectors.selectFetchCountByKeyWindow(state, {transactionId})
const selectAvailableRefinancingPartnersHasLoaded = createSelector(
  selectAvailableRefinancingPartnersFetchCount,
  getFetchCount => transactionId => getFetchCount(transactionId) > 0
)

export const {
  selectByKeyWindow,
  selectIsKeyWindowLoading: selectAvailableRefinancingPartnersIsLoading,
  selectIsKeyWindowError,
} = selectors

export const selectAvailableRefinancingPartnersByTransactionId = state => transactionId =>
  selectByKeyWindow(state, {transactionId})

const aFetchAvailableRefinancingPartners = transactionId => actions.fetch({transactionId})

export const selectAvailableRefinancingPartnersHasError = state => transactionId =>
  selectIsKeyWindowError(state, {transactionId})

export const aEnsureAvailableRefinancingPartners = transactionId => (dispatch, getState) => {
  if (
    selectAvailableRefinancingPartnersIsLoading(getState(), {transactionId}) ||
    selectAvailableRefinancingPartnersHasLoaded(getState())(transactionId)
  ) {
    return
  }
  dispatch(aFetchAvailableRefinancingPartners(transactionId))
}
